module.exports = __webpack_public_path__ + "img/e1239716648c475ff72e1cf7510a50fa.png";